export default __webpack_public_path__ + "static/media/sms_slide1.298f7a64.jpg";